import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend, Label
} from "reactstrap"
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import { accessRole } from '../../../../../helpers/access_role'
import Select from '../../../../../helpers/ui/CustomSelect'
import { FileInput, generateFormData } from '../../../../../helpers/ui/FileInput'
import { AvForm, AvField } from "availity-reactstrap-validation"

import { Link, Redirect } from "react-router-dom"

import apiResponse from '../../../../../services/apiResponse'
import { cancelToken } from '../../../../../services/adapters/kepegawaian/menuService'

import IndexBloc from '../Index/Blocs/IndexBloc'
import UpdateBloc from './Blocs/UpdateBloc'


class UpdateView extends Component {
    // Retrieve Data Pegawai by Admin / Pegawai
    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    peg_uuid = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_uuid : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_uuid : "")

    source
    updateBloc = new UpdateBloc();
    indexBloc = new IndexBloc()
    timer

    constructor(props) {
        super(props)
        this.state = {
            employeeOption: [],
            options: [],
            detail: {},
            oversea: 1,
            employeeFilter: {
                filter_value: "",
                page_number: 1,
                page_size: 50,
                sort_order: {
                    column: 'employee_id',
                    order: 'asc' 
                }
            }
        }

    }

    handleSelectInputChange = value => {
        clearTimeout(this.timer)

        this.state.employeeFilter.filter_value = value

        this.timer = setTimeout(() => this.loadEmployeeList(), 800);
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                official_travel_uuid: this.props.uuid,
                ...values
            },
            confirm: true
        })
    }

    submitData = async () => {
        const dataForm = generateFormData(this.state.dataForm, 'file')
        await this.updateBloc.fetchUpdate(dataForm)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    loadEmployeeList = async () => {
        let offset = (this.state.employeeFilter.page_number-1)*this.state.employeeFilter.page_size
        const query = {
            search: this.state.employeeFilter.filter_value,
            limit: this.state.employeeFilter.page_size,
            offset: offset,
            order: this.state.employeeFilter.sort_order.column,
            sort: this.state.employeeFilter.sort_order.order,
            status: 1
        }
        await this.indexBloc.fetchEmployeeList(query, this.source.token)
    }

    loadDetail = async () => {
        const query = {
            uuid: this.props.uuid
        }
        await this.indexBloc.fetchDetail(query, this.source.token)
    }

    getCity = (province_uuid) => {
        this.indexBloc.regionCityChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ cityOption: result.data.response.result })
                    break;
                default:
                    break;
            }
        })
        const query = { 
            is_local: 1,
            type : 3,
            parent_uuid : province_uuid
        }
        this.indexBloc.fetchRegionCity(query, this.source.token)
    }

    loadProvince = async () => {
        const query = { 
            parent_uuid: '61b47307-167d-489f-bb6c-c1c9662acab3',
            type: 2
        }
        await this.indexBloc.fetchRegionProvince(query, this.source.token)
    }



    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadDetail()
        this.loadEmployeeList()
        this.loadProvince()
    }

    handleDelete = (index, e) => {
        let stateClone = JSON.parse(JSON.stringify(this.state.options));
        stateClone.splice(index, 1);
        this.setState({ options: stateClone });
        e.preventDefault();
    }

    handleClick = (e) => {
        let stateClone = JSON.parse(JSON.stringify(this.state));
        stateClone.options.push(this.defaultOption);
        this.setState({ options: stateClone.options });
        e.preventDefault();
    }

    customRow = (options) => {
        const listItems = options.map((cusRow, index) => (
                <Row className="mb-4">
                    <Label htmlFor="horizontal-password-input" className="col-md-2 col-form-label"></Label>
                    <Col sm={4}>
                        <Select
                            name={`official_travel_participant_employee_uuid[${index+1}]`}
                            placeholder="Pilih Partisipan"
                            errorMessage="Silahkan Pilih Partisipan"
                            className="form-control"
                            validate={{ required: { value: true } }}
                            options={this.state.employeeOption?.result}
                            optionLabel={opt => opt.employee_name + ' - ' + opt.employee_current_position_name}
                            optionValue="employee_uuid"
                            onInputChange={value => this.handleSelectInputChange(value)}
                        />
                    </Col>
                    <Col sm={2}>
                        <AvField
                            name={`official_travel_participant_start_date[${index+1}]`}
                            placeholder="Tanggal Mulai"
                            type="date"
                            errorMessage="Masukkan Tanggal Mulai"
                            className="form-control"
                            validate={{ required: { value: true } }}
                        />
                    </Col>
                    <Col sm={2}>
                        <AvField
                            name={`official_travel_participant_end_date[${index+1}]`}
                            placeholder="Tanggal Akhir"
                            type="date"
                            errorMessage="Masukkan Tanggal Akhir"
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="perjadin_participant_enddate"
                        />
                    </Col>
                    <Col sm={1}>
                        <Button color="danger" type="button" title="Hapus participant" onClick={(e) => this.handleDelete(index, e)}>
                            <i className="uil-minus"></i>
                        </Button>
                    </Col>
                </Row>
            )
        );
        return (
            listItems
        )
    }



    componentDidMount = () => {
        this.setTokenAPI()

        this.indexBloc.employeeListChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ employeeOption: result.data.response })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.regionProvinceChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ provinceOption: result.data.response.result })
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ 
                        detail: result.data.response, 
                        domicile: result.data.response.official_travel_domicile, 
                        oversea: result.data.response.official_travel_oversea,
                    })
                    this.getCity(result.data.response.official_travel_province_uuid)
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.updateBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

    }

    componentWillUnmount = () => {
        this.indexBloc.employeeListChannel?.unsubscribe()
    }

    render() {
        let { options, detail } = this.state;
        let { result } = this.state.employeeOption
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col md="12">
                            <Card>
                                <CardBody>
                                    <div className="float-end">
                                        <Link to={`?list&uuid=${this.peg_uuid}`}>
                                            <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                        </Link>
                                    </div>
                                    <CardTitle>Pengajuan Perjalanan Dinas</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Nomor <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="4">
                                                <AvField 
                                                    type="text" 
                                                    placeholder="Nomor Perjalanan Dinas"
                                                    errorMessage="Masukkan Nomor Perjalanan Dinas"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    name="official_travel_number"
                                                    value={detail?.official_travel_number}    
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Mulai <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="2">
                                                <AvField
                                                    name="official_travel_date"
                                                    value={detail?.official_travel_date}
                                                    placeholder="Tanggal Perjalanan Dinas"
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal Perjalanan Dinas"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Selesai Dinas <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="2">
                                                <AvField
                                                    name="official_travel_end_date"
                                                    value={detail?.official_travel_end_date}
                                                    placeholder="Tanggal Selesai Perjalanan Dinas"
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal Selesai Perjalanan Dinas"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Tempat Dinas <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="3">
                                                <Select
                                                    name="official_travel_oversea"
                                                    placeholder="Tempat Dinas"
                                                    errorMessage="Masukkan Tempat Dinas"
                                                    validate={{ required: { value: true } }}
                                                    options={[
                                                        {value: 1, label: 'Dalam Negeri'},
                                                        {value: 2, label: 'Luar Negeri'}
                                                    ]}
                                                    onChange={opt => this.setState({ oversea: opt.value })}
                                                    isSearchable={true}
                                                    defaultValue={this.state.oversea}
                                                />
                                            </Col>
                                        </Row>

                                        {this.state.oversea == 1 &&
                                            <Fragment>
                                                <Row className="mb-3">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                    </Label>
                                                    <Col md="3">
                                                        <Select
                                                            name="official_travel_domicile"
                                                            placeholder="Tempat Dinas"
                                                            errorMessage="Masukkan Tempat Dinas"
                                                            validate={{ required: { value: true } }}
                                                            options={[
                                                                {value: 1, label: 'Dalam Kota'},
                                                                {value: 2, label: 'Luar Kota'}
                                                            ]}
                                                            onChange={opt => this.setState({ domicile: opt.value })}
                                                            isSearchable={true}
                                                            defaultValue={this.state.domicile}
                                                        />
                                                    </Col>
                                                </Row>
                                                
                                                {this.state.domicile == 2 &&
                                                    <Fragment>
                                                        <Row className="mb-3">
                                                            <Label
                                                                className="col-md-2 col-form-label"
                                                            >
                                                            Provinsi <span className="text-danger">*</span>
                                                            </Label>
                                                            <Col md="3">
                                                                <Select 
                                                                    name="official_travel_province_uuid"
                                                                    errorMessage="Pilih Provinsi"
                                                                    onChange={value => this.getCity(value.region_uuid)}
                                                                    options={this.state.provinceOption}
                                                                    defaultValue={detail?.official_travel_province_uuid}
                                                                    optionLabel="region_name"
                                                                    optionValue="region_uuid" 
                                                                    validate={{ required: { value: true } }}
                                                                    placeholder="Pilih Provinsi"
                                                                />
                                                            </Col>
                                                        </Row>
                                                        <Row className="mb-3">
                                                            <Label
                                                                className="col-md-2 col-form-label"
                                                            >
                                                                Kota <span className="text-danger">*</span>
                                                            </Label>
                                                            <Col md="3">
                                                                <Select 
                                                                    name="official_travel_city_uuid"
                                                                    errorMessage="Pilih Kota Lahir"
                                                                    options={this.state.cityOption} 
                                                                    optionLabel="region_name"
                                                                    defaultValue={detail?.official_travel_city_uuid}
                                                                    optionValue="region_uuid"
                                                                    validate={{ required: { value: true } }}
                                                                    placeholder="Pilih Kota Lahir"
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </Fragment>
                                                }
                                            </Fragment>
                                        }

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Tujuan <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="5">
                                                <AvField
                                                    name="official_travel_destination"
                                                    value={detail?.official_travel_destination}
                                                    placeholder="Tujuan Perjalanan Dinas"
                                                    type="textarea"
                                                    rows="5"
                                                    errorMessage="Masukkan Tujuan Perjalanan Dinas"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Keterangan 
                                            </Label>
                                            <Col md="5">
                                                <AvField
                                                    value={detail?.official_travel_description}
                                                    name="official_travel_description"
                                                    placeholder="Keterangan Perjalanan Dinas"
                                                    type="textarea"
                                                    rows="5"
                                                    className="form-control"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label className="col-md-2 col-form-label">
                                                Upload ST <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="5">
                                                <FileInput 
                                                    name="file"
                                                    value={detail?.document}
                                                />
                                            </Col>
                                        </Row>

                                            {/* {detail?.participant?.map((val, i) => {
                                                let name = val.employee?.employee_name
                                                let front_title = val.employee?.employee_front_title ? val.employee?.employee_front_title + '. ' : ''
                                                let end_title = val.employee?.employee_end_title ? ' ' + val.employee?.employee_end_title : ''
                                                name = front_title + name + end_title
                                                return (
                                                    <Row className="mb-4">
                                                        <Label htmlFor="horizontal-password-input" className="col-md-2 col-form-label">Partisipan  <span className="text-danger">*</span></Label>
                                                        <Col sm={4}>
                                                            <AvField
                                                                name="official_travel_participant_employee_uuid[0]"
                                                                placeholder="Tanggal Mulai"
                                                                type="text"
                                                                errorMessage="Masukkan Tanggal Mulai"
                                                                className="form-control"
                                                                value={name}
                                                                readOnly={true}
                                                            />
                                                        </Col>
                                                        <Col sm={2}>
                                                            <AvField
                                                                name="official_travel_participant_start_date[0]"
                                                                placeholder="Tanggal Mulai"
                                                                type="date"
                                                                errorMessage="Masukkan Tanggal Mulai"
                                                                className="form-control"
                                                                value={val.official_travel_participant_start_date}
                                                                readOnly={true}
                                                            />
                                                        </Col>
                                                        <Col sm={2}>
                                                            <AvField
                                                                name="official_travel_participant_end_date[0]"
                                                                placeholder="Tanggal Akhir"
                                                                type="date"
                                                                errorMessage="Masukkan Tanggal Akhir"
                                                                className="form-control"
                                                                value={val.official_travel_participant_end_date}
                                                                readOnly={true}
                                                            />
                                                        </Col>
                                                        {i == 0 &&
                                                            <Col sm={1}>
                                                                <Button color="primary" type="button" title="Tambah Partisipan" onClick={e => this.handleClick(e)}>
                                                                    <i className="uil-plus"></i>
                                                                </Button>
                                                            </Col>
                                                        }
                                                    </Row>                                                    
                                                )
                                            })}
                                                                               
                                        {this.customRow(options)}
 */}
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to={`?list`}>
                                                    <Button color="danger" type="button"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>

                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>


                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to={`/izinpegawai/dinas.html`} />
                : null }

            </Fragment>
        )
    }


}

export default UpdateView;